import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from './BetaPreviewPage.module.sass'
import Container from "../../components/UI/Container/Container";

export const BetaPreviewPage = () => {
    const [memberToken, setMemberToken] = useState('');

    return <Container>

        <div className={styles['links']} >

            <ol>
                <li>
                    <Link to={'/orders'}>Orders</Link>
                </li>

                <li>
                    <Link to={`/member_new/${memberToken}/info`}>New member page</Link>

                    <label>Token: </label>
                    <input type="text" value={memberToken} onChange={(e) => setMemberToken(e.target.value)}></input>
                </li>


            </ol>
        </div>

    </Container>
}